<template>
  <div class="wl-certification-lecturer wl-index-wrapper">
    <div class="wl-certification-lecturer-conte clearfix">
      <div class="wl-sidebar-menu">
        <div class="wl-lecturer-back clearfix" :style="{backgroundImage: 'url(' + (back) + ')'}">
          <div class="menu-sp-text">L</div>
          <div class="menu-sp-left">
            <p class="p-text-tea">培训讲师</p>
            <p class="p-text-ecturer">ECTURER</p>
          </div>
        </div>
        <ul>
          <li @click="tabSwitch('authen')" :class="{'active_tea': isTab == 'authen'}">
            讲师申请标准
            <i class="wl-icon-xiangyou"></i>
          </li>
          <li @click="tabSwitch('train')" :class="{'active_tea': isTab == 'train'}">
            讲师培训活动
            <i class="wl-icon-xiangyou"></i>
          </li>
          <li @click="tabSwitch('apply')" :class="{'active_tea': isTab == 'apply'}">
            申请成为讲师
            <i class="wl-icon-xiangyou"></i>
          </li>
        </ul>
      </div>
      <div class="wl-certification-content">
        <div class="authen-hade-title clearfix">
          <h3 class="h3-text-title">
            <span v-show="isTab == 'authen'">讲师申请标准</span>
            <span v-show="isTab == 'train'">讲师培训活动</span>
            <span v-show="isTab == 'apply'">申请成为讲师</span>
          </h3>
          <div class="authen-hade-crumbs">
            <i class="wl-icon-zhuye1"></i>
            <span>当前位置：</span>
            <span @click="goHome">网站首页</span>
            <span>></span>
            <span v-show="isTab == 'authen'">讲师申请标准</span>
            <span v-show="isTab == 'train'" @click="goTeaActive">讲师培训活动</span>
            <span v-show="isTab == 'apply'">申请成为讲师</span>
            <span v-show="!isShowDetail">
              <span>></span>
              <span>{{activeTitle}}</span>
            </span>
          </div>
        </div>
        <div class="border-class-content" v-show="isTab == 'authen'">
          <div class="lecturer-certi-standard">
            <div v-for="(item,index) in TeaAuthenticaList" :key="index">
              <h3 class="h3-wl-title">
                <span class="sp-border-class"></span>
                <span class="sp-title-text">{{item.title}}</span>
              </h3>
              <div class="exam-text-content">
                <span v-html="item.content"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="training-lecturer-active" v-show="isTab == 'train'">
          <div class="training-lecturer-active-list" v-show="isShowDetail">
            <div
              class="training-active-list"
              v-for="(item,index) in activeList"
              :key="index"
              @click="goActiveDetail(item.title,item.id)"
            >
              <div class="training-active-li">
                <p class="p-title-text">
                  <i class="wl-icon-zhedie"></i>
                  {{item.title}}
                </p>
                <p class="p-content-text" v-html="item.content"></p>
                <p class="p-source-text clearfix">
                  <span class="sp-left">来源：{{item.source}}</span>
                  <span class="sp-right">{{item.pulishTime}}</span>
                </p>
              </div>
            </div>
            <div class="el-block-pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="onPageChangeHandler"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 40, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
              ></el-pagination>
            </div>
          </div>
          <activeDetail v-if="!isShowDetail" :activeId="activeId"></activeDetail>
        </div>
        <div class="apply-training-flow" v-show="isTab == 'apply'">
          <div class="content-class-border">
            <h3 class="h3-wl-title">
              <span class="sp-border-class"></span>
              <span class="sp-title-text">讲师认证流程</span>
            </h3>
            <div class="exam-text-content">
              <p>
                <img :src="roleImg" alt>
              </p>
            </div>
            <h3 class="h3-wl-title">
              <span class="sp-border-class"></span>
              <span class="sp-title-text">查看讲师协议</span>
            </h3>
            <div class="exam-text-content">
              <div class="file-class-text clearfix">
                <p>北京中物联物流采购培训中心关于培训讲师的合作协议2019版.doc</p>
                <a href="http://file.clpp.org.cn/66ykt/ori/62aoalgo67ralzns3hnyea/y8FdfX3Xa5XJBmk6.xls?response-content-disposition=attachment;filename=北京中物联物流采购培训中心训部培训讲师申请表.doc" class="a-download-text">点击下载</a>
              </div>
            </div>
            <h3 class="h3-wl-title">
              <span class="sp-border-class"></span>
              <span class="sp-title-text">讲师证讲师申请表</span>
            </h3>
            <div class="exam-text-content">
              <div class="file-class-text clearfix">
                <p>北京中物联物流采购培训中心训部培训讲师申请表.doc</p>
                <a href="http://file.clpp.org.cn/66ykt/ori/62aoalgo67ralzns3hnyea/y8FdfX3Xa5XJBmk6.xls?response-content-disposition=attachment;filename=北京中物联物流采购培训中心训部培训讲师申请表.doc" class="a-download-text">点击下载</a>
              </div>
              <div class="apply-button" @click="applyTea">立即申请讲师</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :show-close="true"
      :visible.sync="scanVisible"
      top="12%"
      width="500px"
      class="unified-login-dialog-style"
      :close-on-click-modal="false">
      <!-- <div class="login-role-tab">
        <div
          class="login-role-tab-li"
          @click="roleTab('1')"
          :class="{'active_role' : isRoleTab == '1'}"
        >我是学员</div>
        <div
          class="login-role-tab-li"
          @click="roleTab('2')"
          :class="{'active_role' : isRoleTab == '2'}"
        >我是讲师</div>
      </div> -->
      <div class="login-hade-tab clearfix">
        <div
          class="user-account-login"
          @click="switchTab('account')"
          :class="{'active_login' : isLoginTab == 'account'}"
        >账号登录</div>
        <div
          class="user-phone-login"
          @click="switchTab('phone')"
          :class="{'active_login' : isLoginTab == 'phone'}"
        >手机号登录</div>
      </div>
      <div class="login-form-input clearfix">
        <el-form ref="form" :model="ruleForm" :rules="rules">
          <div class="from-account-login" v-show="isLoginTab == 'account'">
            <el-form-item prop="userName">
              <el-input placeholder="请输入账号" prefix-icon="wl-icon-user" v-model="ruleForm.userName"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="请输入密码"
                prefix-icon="wl-icon-mimaicon"
                v-model="ruleForm.password"
                type="password"
                @keyup.enter.native="login()"
              ></el-input>
            </el-form-item>
          </div>
          <div class="from-phone-login" v-show="isLoginTab == 'phone'">
            <el-form-item prop="phone">
              <el-input
                placeholder="请输入手机号"
                prefix-icon="wl-icon-shouji2"
                v-model="ruleForm.phone"
                @blur="verificationMobile"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="captcha-phone-input">
                <el-input
                  placeholder="请输入手机验证码"
                  prefix-icon="wl-icon-2yanzhengma"
                  v-model="ruleForm.captcha"
                ></el-input>
              </div>
              <el-button
                v-show="show1"
                type="primary"
                class="captcha-phone-button"
                @click="sendMessage()"
              >获取验证码</el-button>
              <el-button v-show="show2" type="primary" class="captcha-phone-button">{{count}}s</el-button>
              <el-button
                v-show="show3"
                type="primary"
                class="captcha-phone-button"
                @click="sendMessage()"
              >重新获取验证码</el-button>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button v-if="isLoginTab == 'account'" type="primary" @click="login">登录</el-button>
            <el-button v-if="isLoginTab == 'phone'" type="primary" @click="Phonelogin()">登录</el-button>
          </el-form-item>
          <div class="go-register-right" @click="goRegister">
            去注册
            <i class="wl-icon-zhankai"></i>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { MU_UPATE_AUTH } from "store/index";
import activeDetail from "page/component/school/activeDetail.vue";
import redirect from "api/v1.commom.login.ts";
import CryptoJS from "crypto-js";
export default {
  components: {
    activeDetail
  },
  data() {
    return {
      type: 1,
      isTab: "authen",
      back: require("assets/images/bg-js.png"),
      roleImg: require("assets/images/rzlc.png"),
      activeList: [],
      TeaAuthenticaList: [],
      totalCount: 0,
      pageSize: 10,
      pageIndex: 0,
      activeTitle: "",
      isShowDetail: true,
      activeId: "",
      // 登录
      scanVisible: false,
      ruleForm: {
        userName: "",
        password: "",
        phone: "",
        captcha: ""
      },
      rules: {
        userName: [
          { required: true, message: "请输入用户账号", trigger: "change" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "change" }],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" }
        ]
      },
      count: 60,
      show1: true,
      show2: false,
      show3: false,
      isLoginTab: "account",
      isRoleTab: "1",
      isShow: false
    };
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    },
    userInfo() {
      return this.$store.state.auth;
    }
  },
  created() {
    this.getTeaAuthentica();
    this.getTeaAttestaList(1);
  },
  methods: {
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    goTeaActive() {
      this.isShowDetail = true;
    },
    goActiveDetail(title, id) {
      this.isShowDetail = false;
      this.activeTitle = title;
      this.activeId = id;
    },
    tabSwitch(role) {
      this.isTab = role;
      this.isShowDetail = true;
    },
    getTeaAuthentica() {
      let that = this;
      this.$http
        .post("/api/XOrg/LecturerShow/getTeaAuthentica", {
          associationId: this.association.Id
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.TeaAuthenticaList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getTeaAttestaList(page) {
      let that = this;
      this.$http
        .post("/api/XOrg/LecturerShow/getTeaAttestaList", {
          associationId: this.association.Id,
          page: page,
          pageSize: this.pageSize
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.activeList = rst.list;
            that.totalCount = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
          }
        });
    },
    onPageChangeHandler(page) {
      this.getTeaAttestaList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTeaAttestaList(1);
    },
    applyTea() {
      let that = this;
      if (that.userInfo.code > 0 && that.userInfo.userType == 2) {
        this.$router.push({
          name: "teaApplyLecture"
        });
      } else {
        this.scanVisible = true;
      }
    },
    roleTab(role){
      this.isRoleTab = role;
    },
    login: function() {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/Accountlogin", {
          userName: that.ruleForm.userName,
          userPwd: that.ruleForm.password,
          associationId: that.association.Id
        })
        .then(function(rst) {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = that.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            that.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              that.loadingTip(false);
              // 登录完获取回登录信息跳转
              that.scanVisible = false;
              that.$router.push({
                name: "teaApplyLecture"
              });
            });
          } else {
            that.loadingTip(false);
            that.$message.warning(rst.msg);
          }
        });
    },
    //手机登录
    Phonelogin() {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/Phonelogin", {
          phone: that.ruleForm.phone,
          captcha: that.ruleForm.captcha,
          associationId: that.association.Id
        })
        .then(rst => {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = that.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            that.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              that.loadingTip(false);
              // 登录完获取回登录信息跳转
              that.scanVisible = false;
              that.$router.push({
                name: "teaApplyLecture"
              });
            });
          } else {
            that.loadingTip(false);
            that.$message.warning(rst.msg);
          }
        });
    },
    loadingTip(is) {
      // let loading = null;
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录..."
        });
      } else {
        this.$loading({}).close();
      }
    },
    verificationMobile() {
      var re = /^1\d{10}$/;
      if (re.test(this.ruleForm.phone)) {
      } else {
        this.$message.warning("手机号格式不正确");
        return false;
      }
    },
    //验证码
    sendMessage() {
      debugger;
      var once = true;
      let str_ = Date.parse(new Date()) / 1000;
      let str = this.encryption(str_);
      let str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      str1 = s1 + "s" + s2;
      if (once) {
        var that = this;
        this.$http("/api/XOrg/XLogin/sendCode", {
          verifyInfo: this.ruleForm.phone,
          str: str,
          str1: str1
        }).post(rst => {
          if (rst.code > 0) {
            this.$message.success(rst.msg);
            this.verifyCode = rst.verifyCode;
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show1 = false;
              this.show2 = true;
              this.show3 = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                  once = false;
                } else {
                  this.show1 = false;
                  this.show2 = false;
                  this.show3 = true;
                  clearInterval(this.timer);
                  this.timer = null;
                  once = true;
                }
              }, 1000);
            }
          } else {
            this.$message.warning(rst.msg);
          }
        });
      }
    },
    encryption: function(str) {
      let Base64 = require("js-base64").Base64;
      return Base64.encode(str);
    },
    goRegister() {
      this.$router.push({
        name: "register"
      });
    },
    switchTab(content){
      this.isLoginTab = content;
    },
  }
};
</script>
